import { Link } from "gatsby"
import React from "react"

const Navigation = () => {
  return (
    <div className="navigation">
        <div className="nav-items">
          <Link to="/">
            <h1 id="logo">moo</h1>
          </Link>
          <Link  id="nav-link" to="/about">About</Link>
        </div>
    </div>
  );
}


export default Navigation
